var React = require('react');

function ArrowRightBigIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.6364 7.6364C18.9879 7.28493 18.9879 6.71508 18.6364 6.36361L12.9088 0.63604C12.5574 0.284568 11.9875 0.284568 11.636 0.63604C11.2846 0.987512 11.2846 1.55736 11.636 1.90883L16.7272 7L11.636 12.0912C11.2846 12.4426 11.2846 13.0125 11.636 13.364C11.9875 13.7154 12.5574 13.7154 12.9088 13.364L18.6364 7.6364ZM-7.86805e-08 7.9L18 7.9L18 6.1L7.86805e-08 6.1L-7.86805e-08 7.9Z","fill":"current"}));
}

ArrowRightBigIconInline.defaultProps = {"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none"};

module.exports = ArrowRightBigIconInline;

ArrowRightBigIconInline.default = ArrowRightBigIconInline;
